import {PerformerEntity} from "../../../entities/performer.entity";

export class ActivityExecutorParticipant extends PerformerEntity {

  constructor(id?: string, name?: string, type?: string) {
    super(id,name,type);
  }

  activityDefId: string;
  activityDefName: string;
}
